import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { svgProps } from "./defaults";
import { WaveSvg } from "../Wave.styles";
var fixed4 = {
    start: {
        small: /*#__PURE__*/ _jsx(WaveSvg, _object_spread_props(_object_spread({}, svgProps), {
            viewBox: "0 0 375 44",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M375 0H0v2.737c12.513 4.253 24.677 9.16 36.855 14.07C82.515 35.221 128.37 53.713 193.5 38.191 261.527 21.98 296-4.949 375 9.404V0Z"
            })
        })),
        large: /*#__PURE__*/ _jsx(WaveSvg, _object_spread_props(_object_spread({}, svgProps), {
            viewBox: "0 0 1440 169",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M1440 0H0v36s370 146.5 632 86 577.5-42.5 808 47V0Z"
            })
        }))
    },
    end: {
        small: /*#__PURE__*/ _jsx(WaveSvg, _object_spread_props(_object_spread({}, svgProps), {
            viewBox: "0 0 375 87",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M375 9.941V87H0V76.681C25.93 66.14 262.01-27.65 368.34 8.072A66.565 66.565 0 0 0 375 9.941Z"
            })
        })),
        large: /*#__PURE__*/ _jsx(WaveSvg, _object_spread_props(_object_spread({}, svgProps), {
            viewBox: "0 0 1440 206",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M0 185.961v19.207h1440V47.538c-448-109.09-722.5 1.05-839.5 25.522C475 99.31 242 205.168 0 185.96Z"
            })
        }))
    },
    height: {
        small: 701,
        large: 676
    }
};
export { fixed4 };
